module.exports = {
  SERVER: 'https://thegiftguide.com/api',
  APPLINK: 'https://thegiftguide.com'
}